import { InfoCircleOutlined } from '@ant-design/icons';

export function StoreStatus({ status, statusText }: { status: string; statusText: string }) {
  const className = {
    abierta: 'text-success text-[9px]',
    cerrado: 'text-error',
    'cierre temporal': 'text-warning',
  };
  return (
    <p className={`mb-0 mt-[5px] flex items-center gap-[5px] uppercase ${className[status] ?? className.abierta}`}>
      <InfoCircleOutlined className="-mt-px" />
      {statusText}
    </p>
  );
}
